export default {
  'en': {
    fieldnames: {
      login: 'Login',
      password: 'Password',
      newPassword: 'New password',
      email: 'Email address',
      amount: 'Amount',
      date: 'Date',
      bankIdentifier: 'Bank identifier',
      branchIdentifier: 'Branch identifier',
      accountIdentifier: 'Account identifier',
      code: 'Code',
      label: 'Label',
      duration: 'Duration',
      note: 'Note',
      memo: 'Memo',
      dateFormat: 'Date format',
      datePosted: 'Date posted',
      dateUser: 'Date user',
      transactionId: 'Transaction id',
      status: 'Status',
      parent: 'Parent',
      icon: 'Icon',
      isBudgeted: 'Budgeted',
      ipAddress: 'IP address',
      userAgent: 'User agent',
      admin: 'Admin',
      language: 'Language',
      balance: 'Balance',
      updated: 'Updated'
    },
    actions: {
      login: 'Login',
      edit: 'Edit',
      save: 'Save',
      create: 'Create',
      update: 'Update',
      cancel: 'Cancel',
      delete: 'Delete',
      apply: 'Apply',
      refresh: 'Refresh',
      selectAll: 'Select all',
      clear: 'Clear',
      next: 'Next',
      addCategory: 'Add a category',
      addSubcategory: 'Add a subcategory',
      editCategory: 'Edit category',
      addPattern: 'Add pattern',
      suggestPatterns: 'Suggest patterns',
      deletePattern: 'Delete pattern',
      addMap: 'Add a map',
      addUser: 'Add user',
      deleteMap: 'Delete mapping',
      addAccount: 'Add account',
      deleteAccount: 'Delete account',
      download: 'Download',
      uploadOfxJson: 'Upload OFX/JSON',
      uploadOfx: 'Upload OFX',
      uploadIcon: 'Upload icon',
      updateTo: 'Update to'
    },
    labels: {
      login: 'Access to your OwnMyMoney account',
      home: 'Home',
      language: 'Language',
      systemSettings: 'System settings',
      profile: 'Profile',
      about: 'About',
      reportABug: 'Report a bug',
      logout: 'Logout',
      active: 'Active',
      disabled: 'Disabled',
      searchTransactions: 'Search transactions',
      findATransaction: 'Find a transaction',
      batchUpdates: 'Batch updates',
      patternsLabel: 'Automatic categorization',
      categoriesLabel: 'Click to edit category or subcategory or add new one',
      mapsLabel: 'Click to edit transaction mapping or add new one',
      mapLabel: 'Edit transaction mapping',
      profileLabel: 'Update your Money account',
      transactionsByDay: 'Transaction history',
      incomeDistribution: 'Income distribution',
      expenseDistribution: 'Expense distribution',
      nothingToDisplay: 'There is nothing to display',
      nothingToDo: 'There is nothing to do',
      deleteAccount: 'Delete account',
      deleteAccountMsg: 'Are you sure you want to delete this account?<br>All transactions will be deleted too.',
      noAccount: 'There is no account yet',
      fileTooBig: 'File too big',
      mapMustBeSet: 'Map must be set for uploading a JSON file',
      deleteMap: 'Deleting mapping',
      deleteMapMsg: 'Are you sure you want to delete this mapping?',
      deletePattern: 'Deleting pattern',
      deletePatternMsg: 'Are you sure you want to delete this pattern?',
      patternWildcardHelper: 'Wildcard character * is allowed',
      for: 'for',
      typeJsonAttribute: 'Type the JSON attribute',
      isBudgeted: 'Included in budget',
      isNotBudgeted: 'Excluded from the budget',
      isBudgetedHelp: 'Transactions from off-budget categories does not appear in charts',
      uncategorizedTransaction: 'Uncategorized',
      debits: 'Debits',
      credits: 'Credits',
      balances: 'Balances',
      automatic: 'Automatic',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      isOnline: 'You are back online',
      isOffline: 'You are offline',
      aboutText: '<p>Own my money is a simple way to track your bank activity on any device connected to the web (pc, smartphone, tablet, ...).</p><p>If you have any issues or feature requests, please create an <a href="https://github.com/nioc/own-my-money/issues" target="_blank">issue</a>.</p><p>This project is licensed under the <a href="https://www.gnu.org/licenses/quick-guide-gplv3.html" target="_blank">GNU Affero General Public License v3.0</a>.</p>'
    },
    objects: {
      account: 'Account | Accounts',
      category: 'Category | Categories',
      subcategory: 'Subcategory | Subcategories',
      transaction: 'Transaction | Transactions',
      transactionsSelected: 'No transaction selected | 1 transaction selected | {count} transactions selected',
      transactionMapping: 'Transaction mapping',
      user: 'User | Users',
      pattern: 'Pattern | Patterns',
      occurence: 'Occurence | Occurence | Occurences',
      lastDay: 'Last day | Last {count} days',
      lastWeek: 'Last week | Last {count} weeks',
      lastMonth: 'Last month | Last {count} months',
      lastYear: 'Last year | Last {count} years',
      byte: '1 byte | {count} bytes'
    }
  },
  'fr': {
    fieldnames: {
      login: 'Identifiant',
      password: 'Password',
      newPassword: 'Nouveau password',
      email: 'Adresse email',
      amount: 'Montant',
      date: 'Date',
      bankIdentifier: 'Établissement',
      branchIdentifier: 'Guichet',
      accountIdentifier: 'Numéro de compte',
      code: 'Code',
      label: 'Libellé',
      duration: 'Durée',
      note: 'Note',
      memo: 'Mémo',
      dateFormat: 'Format de date',
      datePosted: 'Date de valeur',
      dateUser: 'Date utilisateur',
      transactionId: 'Id transaction',
      status: 'Statut',
      parent: 'Parent',
      icon: 'Icône',
      isBudgeted: 'Budgeté',
      ipAddress: 'Adresse IP',
      userAgent: 'User agent',
      admin: 'Admin',
      language: 'Langue',
      balance: 'Solde',
      updated: 'Mise à jour'
    },
    actions: {
      login: 'Connexion',
      edit: 'Modifier',
      save: 'Enregistrer',
      create: 'Créer',
      update: 'Mettre à jour',
      cancel: 'Annuler',
      delete: 'Supprimer',
      apply: 'Appliquer',
      refresh: 'Rafraîchir',
      selectAll: 'Tout sélectionner',
      clear: 'Vider',
      next: 'Suivant',
      addCategory: 'Ajouter une catégorie',
      addSubcategory: 'Ajouter une sous-catégorie',
      editCategory: 'Modifier une catégorie',
      addPattern: 'Ajouter un modèle',
      suggestPatterns: 'Suggérer des modèles',
      deletePattern: 'Supprimer le modèle',
      addMap: 'Ajouter une correspondance',
      addUser: 'Ajouter un utilisateur',
      deleteMap: 'Supprimer la correspondance',
      addAccount: 'Ajouter un compte',
      deleteAccount: 'Supprimer le compte',
      download: 'Télécharger',
      uploadOfxJson: 'Téléverser OFX/JSON',
      uploadOfx: 'Téléverser OFX',
      uploadIcon: 'Téléverser icône',
      updateTo: 'Mise à jour vers'
    },
    labels: {
      login: 'Accéder à votre compte OwnMyMoney',
      home: 'Accueil',
      language: 'Langue',
      systemSettings: 'Paramètres système',
      profile: 'Profil',
      about: 'À propos',
      reportABug: 'Signaler un bug',
      logout: 'Déconnexion',
      active: 'Actif',
      disabled: 'Désactivé',
      searchTransactions: 'Recherche de transactions',
      findATransaction: 'Rechercher une transaction',
      batchUpdates: 'Modification par lot',
      patternsLabel: 'Classification automatique',
      categoriesLabel: 'Cliquer pour éditer une catégorie ou sous-catégorie ou en créer une nouvelle',
      mapsLabel: 'Cliquer pour editer une correspondance de transaction ou en créer une nouvelle',
      mapLabel: 'Editer la correspondance de transaction',
      profileLabel: 'Mise à jour de votre compte Money',
      transactionsByDay: 'Historique des transactions',
      incomeDistribution: 'Répartition des revenus',
      expenseDistribution: 'Répartition des dépenses',
      nothingToDisplay: 'Il n\'y a rien à afficher',
      nothingToDo: 'Il n\'y a rien à faire',
      deleteAccount: 'Supprimer le compte',
      deleteAccountMsg: 'Etes vous sûr de vouloir supprimer ce compte ?<br>Toutes ses transactions seront supprimées également.',
      noAccount: 'Il n\'y a pas encore de compte',
      fileTooBig: 'Le fichier est trop volumineux',
      mapMustBeSet: 'La map doit être selectionnée pour envoyer un fichier JSON',
      deleteMap: 'Supprimer la correspondance',
      deleteMapMsg: 'Etes vous sûr de vouloir supprimer cette correspondance ?',
      deletePattern: 'Supprimer le modèle',
      deletePatternMsg: 'Etes vous sûr de vouloir supprimer ce modèle ?',
      patternWildcardHelper: 'Le caractère joker * est autorisé',
      for: 'pour',
      typeJsonAttribute: 'Saisir l\'attribut du fichier JSON',
      isBudgeted: 'Inclus dans le budget',
      isNotBudgeted: 'Hors budget',
      isBudgetedHelp: 'Les transactions des catégories hors budget n\'apparaissent pas dans les graphiques',
      uncategorizedTransaction: 'Non classé',
      debits: 'Débits',
      credits: 'Crédits',
      balances: 'Soldes',
      automatic: 'Automatique',
      daily: 'Par jour',
      weekly: 'Par semaine',
      monthly: 'Par mois',
      isOnline: 'Vous êtes à nouveau connecté',
      isOffline: 'Vous êtes hors-ligne',
      aboutText: '<p>Own my money est un outil pour suivre facilement votre activité bancaire depuis n\'importe quel équipement connecté à internet (pc, smartphone, tablette, ...).</p><p>En cas de problème ou pour toute suggestion, merci de créer un <a href="https://github.com/nioc/own-my-money/issues" target="_blank">ticket</a>.</p><p>Ce projet est sous la licence <a href="https://www.gnu.org/licenses/quick-guide-gplv3.html" target="_blank">GNU Affero General Public License v3.0</a>.</p>'
    },
    objects: {
      account: 'Compte | Comptes',
      category: 'Catégorie | Catégories',
      subcategory: 'Sous-catégorie | Sous-catégories',
      transaction: 'Transaction | Transactions',
      transactionsSelected: 'Aucune transaction sélectionnée | 1 transaction sélectionnée | {count} transactions sélectionnées',
      transactionMapping: 'Correspondance de transactions | Correspondances de transactions',
      user: 'Utilisateur | Utilisateurs',
      pattern: 'Modèle | Modèles',
      occurence: 'Occurence | Occurence | Occurences',
      lastDay: 'le jour dernier | Les {count} derniers jours',
      lastWeek: 'La semaine dernière | Les {count} dernières semaines',
      lastMonth: 'Le mois dernier | Les {count} derniers mois',
      lastYear: 'L\'année dernière | Les {count} dernières années',
      byte: '1 octet | {count} octets'
    }
  }
}
